import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CalendarPlus, Menu, UserPlus } from "lucide-react";
import { navForRole, can } from "@/lib/roles";

const TITLES = { today: "My Day", users: "User Management", appointments: "Appointments", summary: "Day Summary", reports: "Doctor Reports", profile: "My Profile" };

export default function DashboardHeader({ active, onNav, onAddDoctor, onNewAppointment, onAddUser, role }) {
  const [mobileNav, setMobileNav] = useState(false);
  const go = (k) => { onNav(k); setMobileNav(false); };
  const nav = navForRole(role);

  let action = null;
  if (active === "doctors" && can(role, "doctors:write"))
    action = <Button data-testid="add-doctor-button" onClick={onAddDoctor} className="bg-teal-600 hover:bg-teal-700 text-white"><UserPlus className="h-4 w-4 mr-2" /> Add Doctor</Button>;
  else if (active === "users" && can(role, "users:manage"))
    action = <Button data-testid="add-user-button" onClick={onAddUser} className="bg-teal-600 hover:bg-teal-700 text-white"><UserPlus className="h-4 w-4 mr-2" /> Add User</Button>;
  else if (can(role, "appointments:create"))
    action = <Button data-testid="book-appointment-button" onClick={onNewAppointment} className="bg-teal-600 hover:bg-teal-700 text-white"><CalendarPlus className="h-4 w-4 mr-2" /> New Appointment</Button>;

  return (
    <>
      <header className="no-print h-20 bg-white border-b border-slate-200 flex items-center justify-between px-5 sm:px-8 sticky top-0 z-20">
        <div className="flex items-center gap-3">
          <button className="md:hidden" onClick={() => setMobileNav((v) => !v)} aria-label="Toggle navigation"><Menu className="h-6 w-6" /></button>
          <div>
            <h1 className="font-head text-xl sm:text-2xl font-bold text-slate-900 capitalize">{TITLES[active] || active}</h1>
            <p className="text-xs text-slate-400 hidden sm:block">Manage patient visits, doctors & receipts</p>
          </div>
        </div>
        {action}
      </header>
      {mobileNav && (
        <div className="md:hidden bg-[#0F172A] text-slate-200 px-5 py-3 no-print">
          {nav.map((k) => <button key={k.key} onClick={() => go(k.key)} className="block w-full text-left py-2">{k.label}</button>)}
        </div>
      )}
    </>
  );
}
